import {
  APPLICATION_CHECKLIST_SIDEBAR_WIDTH_PX,
  APPLICATION_CHECKLIST_TAB_SCROLL_BELOW_PX,
  APPLICATION_CHECKLIST_TAB_STRIP_GAP_PX,
} from '../constants/checklistLayout'
import type { ChecklistTabStripWidthInput } from '../types/utils'

/**
 * Max width so the tab strip ends just before the fixed underwrite checklist,
 * with a small gap. Matches `.checklistRight { width: min(420px, 100vw) }`.
 */
export function computeTabStripMaxWidthAgainstChecklist({
  stripLeft,
  viewportWidth,
  checklistWidthPx = APPLICATION_CHECKLIST_SIDEBAR_WIDTH_PX,
  gapPx = APPLICATION_CHECKLIST_TAB_STRIP_GAP_PX,
}: ChecklistTabStripWidthInput): number {
  if (viewportWidth <= 0) return 0
  const checklistWidth = Math.min(checklistWidthPx, viewportWidth)
  const checklistLeft = viewportWidth - checklistWidth
  return Math.max(0, Math.floor(checklistLeft - gapPx - stripLeft))
}

/** Horizontal tab scroll while underwrite popup is open and viewport is below 1250px. */
export function shouldScrollApplicationTabsWithChecklist(
  checklistOpen: boolean,
  viewportWidth: number,
  scrollBelowPx = APPLICATION_CHECKLIST_TAB_SCROLL_BELOW_PX,
): boolean {
  return checklistOpen && viewportWidth < scrollBelowPx
}
